<template>
  <file-list></file-list>
</template>
<script>
import fileList from '../../components/FileList.vue'
import { mapState, mapMutations } from 'vuex'
export default {
  created () {
  },
  mounted () {
  },
  data () {
    return {
    }
  },
  components: {
    fileList
  },
  methods: {
    ...mapMutations(['setFilesList', 'setTagsList'])
  },
  computed: {
    ...mapState(['filesList', 'tagsList']),
    fileAllList () {
      let list = []
      this.filesList.forEach(f => {
        if (f.parentGuid) {
          f.showOperateFlag = false
          list.push(f)
        }
      })
      return list
    }
  }
}
</script>

<style>

</style>



// WEBPACK FOOTER //
// src/pages/netDisk/GenechemFile.vue